import { take, mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/observable/of';
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { of } from 'rxjs';
import { VisitasService } from '../../visitas/services/visitas.service';
import { VisitadosService } from '../services/visitados.services';

@Injectable({
  providedIn: 'root'
})

export class ResolveVisitadosService implements Resolve<any> {

  situcao = 'VISITADA,EM_ANALISE';

  constructor(
    private visitadosService: VisitadosService) { }

  resolve(): Observable<any> {
    return this.visitadosService.page(this.situcao, 1, 10).pipe(
      take(1),
      mergeMap(visita => {
      return of(visita['object']);
      })
    );
  }

}
